/**
 * 画面のテナント。
 *
 * どのテナント向けの画面かは**ビルド時**に決まる（テナントごとに別配信＝Pages
 * プロジェクト）。実行時にホスト名を見て判別しない: この画面は Remix の SPA モードで
 * favicon とハイドレート前のローディング画面がビルド時に確定するため、実行時判別では
 * それらが既定テナントのブランドのまま一瞬表示されてしまう（design D5）。
 *
 * ブランドの適用先と認証先のテナントは、いずれもこの値から決める。
 */

/** 既定テナントの識別子。バックエンドの `id.DefaultTenantID` と一致させる。 */
export const DEFAULT_TENANT_ID = 'roxx';

/**
 * 画面のテナント識別子を返す。
 *
 * ビルド時に与えられていない配信（既定テナント向けの既存の配信）は既定テナントとして
 * 振る舞う。
 */
export const screenTenantID = (): string => {
  const given = import.meta.env.VITE_TENANT_ID?.trim();
  if (!given) {
    return DEFAULT_TENANT_ID;
  }
  return given;
};

/** 画面のテナントが既定テナントかどうかを返す。 */
export const isDefaultTenantScreen = (): boolean => screenTenantID() === DEFAULT_TENANT_ID;
